/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "typeface-poppins"
import "typeface-source-sans-pro"
import "./src/styles/mixins.scss"
import "./src/styles/animations.scss"
import "./src/styles/buttons.scss"

// Reload when a service worker updates
// https://www.gatsbyjs.org/docs/add-offline-support-with-a-service-worker/#displaying-a-message-when-a-service-worker-updates
export const onServiceWorkerUpdateReady = () => {
  window.location.reload(true) // déprécié -> A remplacer
}
